import type { GetInternalAuditReportDocumentResultsByDocumentIdResponseRow } from '@risksmart-app/trpc/src/types';
import type { GetInternalAuditReportDocumentAssessmentResultsByDocumentIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetInternalAuditReportDocumentAssessmentResultsByDocumentIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetDocumentInternalAuditResultsByDocumentIdArgs = {
  documentId: string;
};

export const useGetDocumentInternalAuditResultsByDocumentId = createQueryHook<
  UseGetDocumentInternalAuditResultsByDocumentIdArgs,
  GetInternalAuditReportDocumentResultsByDocumentIdResponseRow[],
  GetInternalAuditReportDocumentAssessmentResultsByDocumentIdQuery
>({
  trpcQueryOptions: (trpc, { documentId }) =>
    trpc.frontend.internalAuditResult.documentInternalAuditResultsByDocumentId.queryOptions(
      { documentId }
    ),
  mapTrpcDataToGraphQL: (data) => ({
    document_internal_audit_result: data,
  }),
  graphqlDocument:
    GetInternalAuditReportDocumentAssessmentResultsByDocumentIdDocument,
  graphqlVariables: ({ documentId }) => ({ ParentId: documentId }),
});
